var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.showAlert)?_c('Alert',{attrs:{"onEvent":_vm.onAlertEvent}}):_vm._e(),_vm._v(" "),(1==_vm.showScene)?_c('Scene1'):_vm._e(),_vm._v(" "),(2==_vm.showScene)?_c('Scene2'):_vm._e(),_vm._v(" "),(3==_vm.showScene)?_c('Scene3'):_vm._e(),_vm._v(" "),(4==_vm.showScene)?_c('Scene4'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-365a3958","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/director/Director.vue
// module id = null
// module chunks = 